/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import CompanyDetailsCommonHeader from "../CompanyDetailsCommonHeader/CompanyDetailsCommonHeader";
import CompanyGoalHeader from "./Header/CompanyGoalHeader";
import SaveGoalPopup from "./Popup/SaveGoalPopup";

import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";


import SaveContractPopup from "./Popup/SaveGoalPopup";
import { Save } from "@mui/icons-material";

const CompanyGoalBody = () => {
  const { t, i18n } = useTranslation(); //for translation

  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const moduleAccess = localStorage.getItem("moduleaccess");

  const [isLoading, setIsLoading] = useState(false);
  const [contractList, setContractList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedGoalIds, setSelectedGoalIds] = useState([]);
  const [selectedGoalId, setSelectedGoalId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all company goals
  const getAllCompanyGoals = async () => {

    setRowSelection({});
    setSelectedGoalIds([]);
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_COMPANY_GOALS +
        `?token=${token}&company=${params.id}`;

      console.log("url of goal list------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in goal list------>", response);

      setIsLoading(false);
      
      if (response.status) {
        setContractList(response.data);
      }

    } catch (error) {
      console.log(error.message);
    }
  };

  //function for change status
  const deleteBulkHandler = async () => {
    if (selectedGoalIds.length > 0) {
      try {

        console.log("selectedGoalIds------>", selectedGoalIds);

        const deleteIds = {
          ids: selectedGoalIds
        }

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_COMPANY_GOAL +
          `?token=${token}`;

        const response = await putData(requestURL, deleteIds);

        // console.log("response in delete bulk member------>", response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setContractList((prevList) =>
              prevList.filter((item) => !selectedGoalIds.includes(item._id))
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select contract for delete");
    }
    setShowAlert(true);
  };

  //function for afterPopupClose
  const afterPopupClose = (data = []) => {
    console.log("data in after popup close------>", data);
    // Ensure data is always an array
    const dataArray = Array.isArray(data) ? data : [data];
    setContractList((prevList) => {
      // Copy the old list
      let updatedList = [...prevList];

      // Loop through each item from the new list
      dataArray.forEach((newItem) => {
        const index = updatedList.findIndex(
          (oldItem) => oldItem._id === newItem._id
        );

        if (index !== -1) {
          // If item exists in the old list, replace it
          updatedList[index] = newItem;
        } else {
          // If item does not exist, add it to the beginning
          updatedList.unshift(newItem);
        }
      });

      return updatedList;
    });
  };

  //material table columns array
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => {
        return (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveGoal"
            aria-controls="saveGoal"
            onClick={() => {
              setSelectedGoalId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        );
      },
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: t("Name"),
    },
     {
      accessorKey: "targetindustry",
      header: t("Target Industry"),
      Cell: ({ row }) => (
        <div className="label border-bottom-0">
          {row.original.targetindustry && (
            <ul className="d-flex flex-wrap gap-2 fs-xs">
              {row.original.targetindustry.map((industryName, index) => {
                return (
                  <li
                    key={index}
                  >
                    {industryName}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      ),
    },
    {
      accessorKey: "offeritem",
      header: "Offer (Product/Service)",
      size: 220, // Increase column width
      Cell: ({ row }) => {
        const offerItem = row.original.offeritem;
        const productName =
          (offerItem === "product" || offerItem === "service") &&
          row.original.productDetails &&
          row.original.productDetails.name
            ? row.original.productDetails.name
            : null;
        return (
          <div>
            <span style={{ fontWeight: 600, color: "#2c3e50" }}>
              {offerItem ? offerItem.charAt(0).toUpperCase() + offerItem.slice(1) : "-"}
            </span>
            {productName && (
              <div className="label border-bottom-0">
                <ul className="d-flex flex-wrap gap-2 fs-xs">
                  <li
                      className="px-2 py-1 gradient-light rounded-5"
                    >
                      {productName}
                    </li>
                </ul>
              </div>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "companysize",
      header: "Company Size",
    },
    {
      accessorKey: "availableactions",
      header: "Available Actions",
      Cell: ({ row }) => {
        const actionsMap = {
          sendmail: "Send Mail",
          call: "Schedule Call",
          addtag: "Assign Tag",
          createtask: "Create Task",
        };
        const actions = row.original.availableactions || {};
        const enabledActions = Object.keys(actionsMap)
          .filter((key) => actions[key])
          .map((key) => actionsMap[key]);
        return (
          <span>
            {enabledActions.length > 0 ? enabledActions.join(", ") : "-"}
          </span>
        );
      }
    },
    {
      accessorKey: "createdAt",
      header: t("Created Date"),
    }
  
  ];

  //* Material React Table Column and States */
  const columns = useMemo(() => initialTableColumns, [i18n.language]);

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key] && key !== "0"
    );

    if (selectedIdsArray.length > 0) {
      setSelectedGoalIds(selectedIdsArray);
    } else {
      setSelectedGoalIds([]);
    }
  }, [rowSelection]);


  // get all company goals
  useEffect(() => {
    if (params.id) {
      getAllCompanyGoals();
    }
  }, [params.id]);


  // Add this function for alert close
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_COMPANY")
  ) {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          {/* ---- companies common header ---- */}
          {params.id && <CompanyDetailsCommonHeader moduleName="goals" />}
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            {/* ------- filter area --------- */}
            <CompanyGoalHeader reloadList={getAllCompanyGoals} />

            {/* ------- list area ---------- */}

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={contractList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection, columnOrder: initialColumnOrder }} //pass our managed row selection state to the table to use
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ---------- popups and modals area --------- */}
        <SaveGoalPopup
          selectedGoalId={selectedGoalId}
          setSelectedGoalId={setSelectedGoalId}
          afterPopupClose={afterPopupClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* --------- add label modal ------------ */}
        <AddLabelModal
          moduleName="goal"
          selectedIds={selectedGoalIds}
          afterTagModalClose={getAllCompanyGoals}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedGoalIds([]);
          }}
          onDelete={deleteBulkHandler}
          moduleName={t("companygoal")}
        />

        {/* ----------- alert notification ------------ */}
        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default CompanyGoalBody;
